/**
 * Item visuals — BIG Looney-Tunes-style artifact bubbles with unique icons.
 * All values are scaled UP from iteration 3.
 */
export const OUTLINE = "#0A0A0A";
export const ARTIFACT_RADIUS = 52; // was 32 — MUCH bigger
export const ARTIFACT_ICON_SIZE = 30; // was 18

export const ITEM_VISUALS = {
  // Paris
  mona_lisa:        { color: "#FFD166", icon: "painting", label: "MONA LISA" },
  eiffel_bolt:      { color: "#C9D1D9", icon: "bolt",     label: "EIFFEL BOLT" },
  croissant:        { color: "#F0A04B", icon: "crescent", label: "CROISSANT" },
  napoleon_hat:     { color: "#1e2f4a", icon: "hat",      label: "NAPOLEON HAT" },
  arc_triomphe:     { color: "#E5C477", icon: "arch",     label: "ARC KEYSTONE" },
  // Detroit
  motown_record:    { color: "#2B2B2B", icon: "disc",     label: "MOTOWN RECORD" },
  model_t:          { color: "#4A4A4A", icon: "key",      label: "MODEL T KEY" },
  spirit_statue:    { color: "#8EC07C", icon: "statue",   label: "SPIRIT STATUE" },
  coney_dog:        { color: "#EE8D5E", icon: "food",     label: "CONEY DOG" },
  renaissance_key:  { color: "#FFD166", icon: "key",      label: "RENAISSANCE KEY" },
  // NYC
  liberty_torch:    { color: "#8FCB9B", icon: "torch",    label: "LIBERTY TORCH" },
  broadway_ticket:  { color: "#FF6B6B", icon: "ticket",   label: "BROADWAY TICKET" },
  subway_token:     { color: "#F5B71B", icon: "disc",     label: "SUBWAY TOKEN" },
  pizza_slice:      { color: "#F5B71B", icon: "slice",    label: "PIZZA SLICE" },
  empire_blueprint: { color: "#5DADE2", icon: "scroll",   label: "EMPIRE BLUEPRINT" },
  // LA
  walk_star:        { color: "#FFD166", icon: "star",     label: "WALK STAR" },
  surfboard:        { color: "#6CC5FF", icon: "board",    label: "SURFBOARD" },
  oscar_trophy:     { color: "#D4AF37", icon: "trophy",   label: "OSCAR" },
  taco_truck:       { color: "#F5B71B", icon: "food",     label: "TACO RECIPE" },
  griffith_telescope:{ color: "#4A90E2", icon: "bolt",    label: "TELESCOPE" },
  // Mexico City
  aztec_stone:      { color: "#E8A04A", icon: "sun",      label: "AZTEC STONE" },
  frida_brush:      { color: "#FF6B6B", icon: "brush",    label: "FRIDA BRUSH" },
  lucha_mask:       { color: "#3B82F6", icon: "mask",     label: "LUCHA MASK" },
  taco_al_pastor:   { color: "#F5B71B", icon: "food",     label: "TACO AL PASTOR" },
  zocalo_flag:      { color: "#2E9D5E", icon: "flag",     label: "ZOCALO FLAG" },
  // London
  big_ben_hand:     { color: "#D4AF37", icon: "bolt",     label: "BIG BEN HAND" },
  double_decker:    { color: "#E74C3C", icon: "bus",      label: "DECKER TOKEN" },
  crown_jewel:      { color: "#9B59B6", icon: "gem",      label: "CROWN JEWEL" },
  tube_map:         { color: "#3B82F6", icon: "scroll",   label: "TUBE MAP" },
  phone_booth:      { color: "#E74C3C", icon: "phone",    label: "PHONE BOOTH" },
  // Beirut
  cedar_branch:     { color: "#2E7D32", icon: "tree",     label: "CEDAR BRANCH" },
  pigeon_rock:      { color: "#A5A5A5", icon: "rock",     label: "PIGEON ROCK" },
  manoushe:         { color: "#E8A04A", icon: "food",     label: "MANOUSHE" },
  roman_pillar:     { color: "#F0E4C7", icon: "pillar",   label: "ROMAN PILLAR" },
  phoenician_coin:  { color: "#D4AF37", icon: "disc",     label: "PHOENICIAN COIN" },
  // Cairo
  pyramid_stone:    { color: "#E8A04A", icon: "pyramid",  label: "PYRAMID STONE" },
  sphinx_nose:      { color: "#D2B48C", icon: "face",     label: "SPHINX NOSE" },
  tut_scarab:       { color: "#F5B71B", icon: "gem",      label: "TUT SCARAB" },
  papyrus_scroll:   { color: "#F0E4C7", icon: "scroll",   label: "PAPYRUS SCROLL" },
  nile_amulet:      { color: "#4A90E2", icon: "gem",      label: "NILE AMULET" },
  // Toronto
  cn_tower_tip:     { color: "#D4D4D4", icon: "tower",    label: "CN TOWER TIP" },
  maple_syrup:      { color: "#8B4513", icon: "bottle",   label: "MAPLE SYRUP" },
  hockey_puck:      { color: "#1a1a1a", icon: "disc",     label: "HOCKEY PUCK" },
  poutine:          { color: "#C4A269", icon: "food",     label: "POUTINE" },
  niagara_flask:    { color: "#4A90E2", icon: "bottle",   label: "NIAGARA FLASK" },
  // Tokyo
  shibuya_sign:     { color: "#FF1493", icon: "flag",     label: "SHIBUYA SIGN" },
  sushi_plate:      { color: "#FFD166", icon: "sushi",    label: "SUSHI PLATE" },
  samurai_sword:    { color: "#B0B6BB", icon: "sword",    label: "KATANA" },
  mtfuji_stone:     { color: "#EEEEEE", icon: "pyramid",  label: "FUJI STONE" },
  anime_cel:        { color: "#FF1493", icon: "painting", label: "ANIME CEL" },
};

export function visualFor(itemId, name) {
  return ITEM_VISUALS[itemId] || { color: "#FFD166", icon: "star", label: (name || "ARTIFACT").toUpperCase() };
}

export function roundRect(ctx, x, y, w, h, r) {
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
}

/**
 * Draw a BIG pulsing artifact with Looney-Tunes shine, wobble + oversize yellow signboard above.
 *
 * If a Nano-Banana-generated PNG icon exists at /api/static/artifacts/{cityId}__{itemId}.png
 * it gets blitted on top of the bubble. Otherwise the original drawn glyph is used.
 */
const _iconCache = {};
const _customIconCache = {};
const BACKEND = (typeof process !== "undefined" && process.env.REACT_APP_BACKEND_URL) || "";
function getArtifactIcon(cityId, itemId) {
  const key = `${cityId}__${itemId}`;
  if (_iconCache[key] !== undefined) return _iconCache[key];
  const img = new Image();
  img.onload = () => { _iconCache[key] = img; };
  img.onerror = () => { _iconCache[key] = null; };
  img.src = `${BACKEND}/api/static/artifacts/${key}.png`;
  _iconCache[key] = "loading";
  return "loading";
}

// Custom-course icons live at a direct URL (the course router writes them
// to /api/static/courses/{course_id}/{item_id}.png). When an item carries
// its own `icon_url`, we lazy-load that absolute URL instead of falling
// back to the city/item registry.
function getCustomIcon(iconUrl) {
  if (!iconUrl) return null;
  if (_customIconCache[iconUrl] !== undefined) return _customIconCache[iconUrl];
  const img = new Image();
  img.onload = () => { _customIconCache[iconUrl] = img; };
  img.onerror = () => { _customIconCache[iconUrl] = null; };
  img.src = iconUrl.startsWith("http") ? iconUrl : `${BACKEND}${iconUrl}`;
  _customIconCache[iconUrl] = "loading";
  return "loading";
}

export function drawArtifact(ctx, item, { radius = ARTIFACT_RADIUS, iconSize = ARTIFACT_ICON_SIZE, cityId = null } = {}) {
  const vis = visualFor(item.id, item.name);
  const t = performance.now();
  const bob = Math.sin(t / 320) * 4;
  // Custom course items carry their own AI-generated icon URL. Prefer it
  // over the city/item registry so player-built courses show the right art.
  const customImg = item.icon_url ? getCustomIcon(item.icon_url) : null;
  const fallbackImg = customImg ? null : (cityId ? getArtifactIcon(cityId, item.id) : null);
  const iconImg = customImg && customImg !== "loading" ? customImg : fallbackImg;
  const hasImage = iconImg && iconImg !== "loading" && iconImg.complete;

  ctx.save();
  ctx.translate(item.x, item.y + bob);
  ctx.lineJoin = "round";
  ctx.lineCap = "round";

  // Subtle pixel-y drop shadow below so the icon "sits" on the ground.
  // Deliberately small and soft — no big halo ring.
  ctx.fillStyle = "rgba(0,0,0,0.28)";
  ctx.beginPath();
  ctx.ellipse(2, radius - 2, radius * 0.55, 4, 0, 0, Math.PI * 2);
  ctx.fill();

  if (hasImage) {
    // FLAT pixel-art icon rendered on the map. No bubble, no halo, no rays.
    const prev = ctx.imageSmoothingEnabled;
    ctx.imageSmoothingEnabled = false;
    const target = radius * 2;
    const ar = iconImg.naturalWidth / iconImg.naturalHeight;
    let dw, dh;
    if (ar > 1) { dw = target; dh = target / ar; }
    else        { dh = target; dw = target * ar; }
    ctx.drawImage(iconImg, -dw / 2, -dh / 2, dw, dh);
    ctx.imageSmoothingEnabled = prev;
  } else {
    // Fallback while the image is still loading: just the vector glyph on
    // a tiny colored square (no big bubble, no ray burst).
    ctx.fillStyle = vis.color;
    ctx.strokeStyle = OUTLINE;
    ctx.lineWidth = 3;
    ctx.beginPath();
    roundRect(ctx, -radius * 0.7, -radius * 0.7, radius * 1.4, radius * 1.4, 4);
    ctx.fill();
    ctx.stroke();
    drawIconGlyph(ctx, vis.icon, 0, 0, iconSize);
  }
  ctx.restore();

  // Signboard above (BIG Looney-Tunes title card)
  drawBigSign(ctx, item.x, item.y - radius - 26, vis.label);
}

function drawBigSign(ctx, cx, cy, text) {
  // Minimal pixel-font label that sits flush on the ground below the icon.
  // No bubble, no rope, just a floating name plate so items "belong" to the
  // map rather than hover behind a cartoon billboard.
  ctx.save();
  ctx.font = "bold 10px 'Press Start 2P', monospace";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.lineWidth = 4;
  ctx.lineJoin = "round";
  // black drop-shadow outline for readability on any background
  ctx.strokeStyle = "rgba(0,0,0,0.9)";
  ctx.strokeText(text, cx, cy + 26);
  ctx.fillStyle = "#FFD166";
  ctx.fillText(text, cx, cy + 26);
  ctx.restore();
}

/**
 * Draw a cartoon icon glyph (scale = "size" roughly the half-bounding-box).
 * All glyphs use thick rounded black outlines.
 */
export function drawIconGlyph(ctx, name, cx, cy, size) {
  ctx.save();
  ctx.translate(cx, cy);
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.lineWidth = 3.5;
  ctx.strokeStyle = OUTLINE;
  const s = size;

  const fs = (color) => { ctx.fillStyle = color; ctx.fill(); ctx.stroke(); };

  switch (name) {
    case "painting": {
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(-s, -s, s * 2, s * 2);
      ctx.strokeRect(-s, -s, s * 2, s * 2);
      ctx.fillStyle = "#E6C78A";
      ctx.fillRect(-s * 0.7, -s * 0.7, s * 1.4, s * 1.4);
      ctx.strokeRect(-s * 0.7, -s * 0.7, s * 1.4, s * 1.4);
      ctx.beginPath(); ctx.arc(0, 0, s * 0.4, 0, Math.PI); ctx.stroke();
      break;
    }
    case "bolt": {
      ctx.beginPath();
      for (let i = 0; i < 8; i++) {
        const a = (i / 8) * Math.PI * 2;
        const r = i % 2 === 0 ? s : s * 0.6;
        if (i === 0) ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r);
        else ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      ctx.closePath();
      fs("#BFC5CC");
      ctx.beginPath(); ctx.arc(0, 0, s * 0.35, 0, Math.PI * 2);
      ctx.fillStyle = OUTLINE; ctx.fill();
      break;
    }
    case "key": {
      ctx.beginPath(); ctx.arc(-s * 0.35, 0, s * 0.45, 0, Math.PI * 2);
      fs("#FFD700");
      ctx.beginPath(); ctx.arc(-s * 0.35, 0, s * 0.18, 0, Math.PI * 2);
      ctx.fillStyle = OUTLINE; ctx.fill();
      ctx.fillStyle = "#FFD700";
      ctx.fillRect(-s * 0.05, -s * 0.12, s, s * 0.24);
      ctx.strokeRect(-s * 0.05, -s * 0.12, s, s * 0.24);
      ctx.fillRect(s * 0.55, s * 0.1, s * 0.14, s * 0.34);
      ctx.strokeRect(s * 0.55, s * 0.1, s * 0.14, s * 0.34);
      break;
    }
    case "disc": {
      ctx.beginPath(); ctx.arc(0, 0, s * 0.9, 0, Math.PI * 2);
      fs("#1A1A1A");
      ctx.beginPath(); ctx.arc(0, 0, s * 0.35, 0, Math.PI * 2);
      fs("#E63946");
      ctx.beginPath(); ctx.arc(0, 0, s * 0.1, 0, Math.PI * 2);
      ctx.fillStyle = OUTLINE; ctx.fill();
      break;
    }
    case "crescent": {
      ctx.beginPath();
      ctx.arc(0, 0, s * 0.9, Math.PI * 0.25, Math.PI * 1.75);
      ctx.arc(s * 0.3, 0, s * 0.55, Math.PI * 1.75, Math.PI * 0.25, true);
      ctx.closePath();
      fs("#F0A04B");
      break;
    }
    case "hat": {
      ctx.beginPath();
      ctx.moveTo(-s, 0);
      ctx.lineTo(-s * 0.55, -s * 0.8);
      ctx.lineTo(s * 0.55, -s * 0.8);
      ctx.lineTo(s, 0);
      ctx.closePath();
      fs("#1e293b");
      ctx.beginPath(); ctx.arc(0, -s * 0.45, s * 0.15, 0, Math.PI * 2);
      fs("#E63946");
      break;
    }
    case "arch": {
      ctx.beginPath();
      ctx.moveTo(-s, s);
      ctx.lineTo(-s, -s * 0.2);
      ctx.arc(0, -s * 0.2, s, Math.PI, 0);
      ctx.lineTo(s, s);
      ctx.closePath();
      fs("#E5C477");
      break;
    }
    case "food": {
      ctx.beginPath(); ctx.arc(0, 0, s * 0.9, 0, Math.PI);
      ctx.closePath();
      fs("#EE8D5E");
      ctx.fillStyle = "#2E7D32";
      ctx.fillRect(-s * 0.7, -s * 0.05, s * 1.4, s * 0.18);
      ctx.strokeRect(-s * 0.7, -s * 0.05, s * 1.4, s * 0.18);
      break;
    }
    case "slice": {
      ctx.beginPath();
      ctx.moveTo(0, -s * 0.9);
      ctx.lineTo(s, s * 0.8);
      ctx.lineTo(-s, s * 0.8);
      ctx.closePath();
      fs("#F5B71B");
      ctx.fillStyle = "#E63946";
      [-0.3, 0.3, 0].forEach((dx, i) => {
        ctx.beginPath();
        ctx.arc(dx * s, 0.1 * s + (i - 1) * 0.2 * s, s * 0.13, 0, Math.PI * 2);
        ctx.fill(); ctx.stroke();
      });
      break;
    }
    case "scroll": {
      ctx.fillStyle = "#FFF6DC";
      ctx.fillRect(-s * 0.9, -s * 0.8, s * 1.8, s * 1.6);
      ctx.strokeRect(-s * 0.9, -s * 0.8, s * 1.8, s * 1.6);
      for (let i = -1; i <= 1; i++) {
        ctx.beginPath();
        ctx.moveTo(-s * 0.6, i * s * 0.3);
        ctx.lineTo(s * 0.6, i * s * 0.3);
        ctx.stroke();
      }
      break;
    }
    case "star": {
      ctx.beginPath();
      for (let i = 0; i < 10; i++) {
        const r = i % 2 === 0 ? s : s * 0.45;
        const a = -Math.PI / 2 + (i * Math.PI) / 5;
        if (i === 0) ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r);
        else ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      ctx.closePath();
      fs("#FFD166");
      break;
    }
    case "trophy": {
      ctx.fillStyle = "#D4AF37";
      ctx.fillRect(-s * 0.6, -s * 0.7, s * 1.2, s * 1.1);
      ctx.strokeRect(-s * 0.6, -s * 0.7, s * 1.2, s * 1.1);
      ctx.fillRect(-s * 0.35, s * 0.4, s * 0.7, s * 0.4);
      ctx.strokeRect(-s * 0.35, s * 0.4, s * 0.7, s * 0.4);
      ctx.beginPath(); ctx.arc(-s * 0.7, -s * 0.2, s * 0.25, Math.PI / 2, -Math.PI / 2, true); ctx.stroke();
      ctx.beginPath(); ctx.arc(s * 0.7, -s * 0.2, s * 0.25, -Math.PI / 2, Math.PI / 2, false); ctx.stroke();
      break;
    }
    case "board": {
      ctx.beginPath(); ctx.ellipse(0, 0, s * 0.4, s, 0, 0, Math.PI * 2);
      fs("#EF7D44");
      ctx.beginPath(); ctx.moveTo(0, -s); ctx.lineTo(0, s); ctx.stroke();
      break;
    }
    case "sun": {
      for (let i = 0; i < 8; i++) {
        ctx.save();
        ctx.rotate((i / 8) * Math.PI * 2);
        ctx.fillStyle = "#FFD166";
        ctx.fillRect(-s * 0.15, -s * 1.15, s * 0.3, s * 0.4);
        ctx.strokeRect(-s * 0.15, -s * 1.15, s * 0.3, s * 0.4);
        ctx.restore();
      }
      ctx.beginPath(); ctx.arc(0, 0, s * 0.6, 0, Math.PI * 2);
      fs("#FFA500");
      break;
    }
    case "brush": {
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.15, -s, s * 0.3, s * 1.6);
      ctx.strokeRect(-s * 0.15, -s, s * 0.3, s * 1.6);
      ctx.beginPath();
      ctx.moveTo(-s * 0.5, -s);
      ctx.lineTo(s * 0.5, -s);
      ctx.lineTo(s * 0.3, -s * 1.5);
      ctx.lineTo(-s * 0.3, -s * 1.5);
      ctx.closePath();
      fs("#E63946");
      break;
    }
    case "mask": {
      ctx.beginPath(); ctx.ellipse(0, 0, s * 0.95, s * 0.8, 0, 0, Math.PI * 2);
      fs("#3B82F6");
      ctx.fillStyle = "#FFFFFF";
      ctx.beginPath(); ctx.arc(-s * 0.35, -s * 0.1, s * 0.2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(s * 0.35, -s * 0.1, s * 0.2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      break;
    }
    case "flag": {
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.1, -s, s * 0.2, s * 2);
      ctx.strokeRect(-s * 0.1, -s, s * 0.2, s * 2);
      ctx.beginPath();
      ctx.moveTo(s * 0.1, -s);
      ctx.lineTo(s * 1.1, -s * 0.6);
      ctx.lineTo(s * 0.1, -s * 0.2);
      ctx.closePath();
      fs("#E63946");
      break;
    }
    case "torch": {
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.2, 0, s * 0.4, s);
      ctx.strokeRect(-s * 0.2, 0, s * 0.4, s);
      ctx.beginPath();
      ctx.moveTo(-s * 0.5, 0);
      ctx.quadraticCurveTo(0, -s * 1.4, s * 0.5, 0);
      ctx.closePath();
      fs("#FF6B35");
      break;
    }
    case "ticket": {
      ctx.fillStyle = "#FFD166";
      ctx.fillRect(-s, -s * 0.6, s * 2, s * 1.2);
      ctx.strokeRect(-s, -s * 0.6, s * 2, s * 1.2);
      ctx.setLineDash([4, 3]);
      ctx.beginPath(); ctx.moveTo(0, -s * 0.5); ctx.lineTo(0, s * 0.5); ctx.stroke();
      ctx.setLineDash([]);
      break;
    }
    case "bus": {
      ctx.fillStyle = "#E74C3C";
      ctx.fillRect(-s, -s * 0.8, s * 2, s * 1.6);
      ctx.strokeRect(-s, -s * 0.8, s * 2, s * 1.6);
      ctx.fillStyle = "#FFFFFF";
      [[-0.8, -0.5], [-0.1, -0.5], [0.3, -0.5]].forEach(([x, y]) => {
        ctx.fillRect(x * s, y * s, s * 0.5, s * 0.3);
        ctx.strokeRect(x * s, y * s, s * 0.5, s * 0.3);
      });
      ctx.fillStyle = OUTLINE;
      ctx.beginPath(); ctx.arc(-s * 0.55, s * 0.75, s * 0.22, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(s * 0.55, s * 0.75, s * 0.22, 0, Math.PI * 2); ctx.fill();
      break;
    }
    case "gem": {
      ctx.beginPath();
      ctx.moveTo(0, -s); ctx.lineTo(s, -s * 0.2); ctx.lineTo(s * 0.5, s);
      ctx.lineTo(-s * 0.5, s); ctx.lineTo(-s, -s * 0.2);
      ctx.closePath();
      fs("#9B59B6");
      ctx.fillStyle = "rgba(255,255,255,0.5)";
      ctx.beginPath();
      ctx.moveTo(0, -s); ctx.lineTo(-s, -s * 0.2); ctx.lineTo(-s * 0.4, -s * 0.1);
      ctx.closePath(); ctx.fill();
      break;
    }
    case "phone": {
      ctx.fillStyle = "#E74C3C";
      ctx.beginPath(); roundRect(ctx, -s * 0.6, -s, s * 1.2, s * 2, 6);
      fs("#E74C3C");
      ctx.fillStyle = "#1a1a1a";
      ctx.fillRect(-s * 0.4, -s * 0.7, s * 0.8, s * 1.2);
      ctx.strokeRect(-s * 0.4, -s * 0.7, s * 0.8, s * 1.2);
      break;
    }
    case "tree": {
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.15, 0, s * 0.3, s);
      ctx.strokeRect(-s * 0.15, 0, s * 0.3, s);
      ctx.beginPath();
      ctx.arc(0, -s * 0.2, s * 0.7, 0, Math.PI * 2);
      ctx.arc(-s * 0.45, s * 0.05, s * 0.45, 0, Math.PI * 2);
      ctx.arc(s * 0.45, s * 0.05, s * 0.45, 0, Math.PI * 2);
      fs("#2E7D32");
      break;
    }
    case "rock": {
      ctx.beginPath();
      ctx.moveTo(-s, s * 0.5);
      ctx.quadraticCurveTo(-s * 1.1, -s * 0.3, -s * 0.3, -s);
      ctx.quadraticCurveTo(s * 0.5, -s, s, -s * 0.3);
      ctx.quadraticCurveTo(s * 1.1, s * 0.4, s * 0.3, s * 0.7);
      ctx.closePath();
      fs("#A5A5A5");
      break;
    }
    case "pillar": {
      ctx.fillStyle = "#F0E4C7";
      ctx.fillRect(-s * 0.5, -s, s, s * 2);
      ctx.strokeRect(-s * 0.5, -s, s, s * 2);
      ctx.fillRect(-s * 0.7, -s, s * 1.4, s * 0.2);
      ctx.strokeRect(-s * 0.7, -s, s * 1.4, s * 0.2);
      ctx.fillRect(-s * 0.7, s * 0.8, s * 1.4, s * 0.2);
      ctx.strokeRect(-s * 0.7, s * 0.8, s * 1.4, s * 0.2);
      break;
    }
    case "pyramid": {
      ctx.beginPath();
      ctx.moveTo(0, -s); ctx.lineTo(s, s); ctx.lineTo(-s, s);
      ctx.closePath();
      fs("#E8A04A");
      ctx.fillStyle = "rgba(0,0,0,0.25)";
      ctx.beginPath(); ctx.moveTo(0, -s); ctx.lineTo(s, s); ctx.lineTo(0, s);
      ctx.closePath(); ctx.fill();
      break;
    }
    case "face": {
      ctx.beginPath(); ctx.arc(0, 0, s * 0.9, 0, Math.PI * 2);
      fs("#D2B48C");
      ctx.fillStyle = OUTLINE;
      ctx.beginPath(); ctx.arc(-s * 0.3, -s * 0.1, s * 0.1, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(s * 0.3, -s * 0.1, s * 0.1, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(0, s * 0.2, s * 0.4, 0, Math.PI); ctx.stroke();
      break;
    }
    case "tower": {
      ctx.fillStyle = "#D4D4D4";
      ctx.fillRect(-s * 0.18, -s, s * 0.36, s * 2);
      ctx.strokeRect(-s * 0.18, -s, s * 0.36, s * 2);
      ctx.beginPath(); ctx.arc(0, -s * 0.4, s * 0.45, 0, Math.PI * 2);
      fs("#A3E4F5");
      break;
    }
    case "bottle": {
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.45, -s * 0.3, s * 0.9, s * 1.2);
      ctx.strokeRect(-s * 0.45, -s * 0.3, s * 0.9, s * 1.2);
      ctx.fillRect(-s * 0.2, -s * 0.8, s * 0.4, s * 0.5);
      ctx.strokeRect(-s * 0.2, -s * 0.8, s * 0.4, s * 0.5);
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(-s * 0.35, -s * 0.05, s * 0.7, s * 0.5);
      ctx.strokeRect(-s * 0.35, -s * 0.05, s * 0.7, s * 0.5);
      break;
    }
    case "sushi": {
      ctx.fillStyle = "#1a1a1a";
      ctx.fillRect(-s * 0.9, -s * 0.3, s * 1.8, s * 0.6);
      ctx.strokeRect(-s * 0.9, -s * 0.3, s * 1.8, s * 0.6);
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(-s * 0.7, -s * 0.15, s * 1.4, s * 0.3);
      ctx.fillStyle = "#FF7F50";
      ctx.fillRect(-s * 0.7, -s * 0.5, s * 1.4, s * 0.25);
      ctx.strokeRect(-s * 0.7, -s * 0.5, s * 1.4, s * 0.25);
      break;
    }
    case "sword": {
      ctx.fillStyle = "#B0B6BB";
      ctx.fillRect(-s * 0.12, -s, s * 0.24, s * 1.6);
      ctx.strokeRect(-s * 0.12, -s, s * 0.24, s * 1.6);
      ctx.fillStyle = "#8B4513";
      ctx.fillRect(-s * 0.3, s * 0.6, s * 0.6, s * 0.3);
      ctx.strokeRect(-s * 0.3, s * 0.6, s * 0.6, s * 0.3);
      break;
    }
    case "statue": {
      ctx.beginPath(); ctx.arc(0, -s * 0.5, s * 0.35, 0, Math.PI * 2);
      fs("#8EC07C");
      ctx.fillRect(-s * 0.4, -s * 0.15, s * 0.8, s * 0.9);
      ctx.strokeRect(-s * 0.4, -s * 0.15, s * 0.8, s * 0.9);
      break;
    }
    default: {
      ctx.beginPath();
      for (let i = 0; i < 10; i++) {
        const r = i % 2 === 0 ? s : s * 0.45;
        const a = -Math.PI / 2 + (i * Math.PI) / 5;
        if (i === 0) ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r);
        else ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      ctx.closePath();
      fs("#FFD166");
    }
  }
  ctx.restore();
}
